export default {"src":"/_next/static/media/aspirants banner.518d0fa3.svg","height":386,"width":667,"blurWidth":0,"blurHeight":0};